import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    cate = '',
    title,
    value,
    summary = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.common.uDictionary.save, {
        id,
        cate,
        title,
        value,
        summary,
    }, options);
    if (error) return { error, status };
    return content || {};
};
